import React from 'react'
import PropTypes from 'prop-types'

import ServiceRow from './ServiceRow'
import ServiceTableHeader from './ServiceTableHeader'
import PhotoScreen from '../../common/PhotoScreen'

export default class ServiceTable extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string,
    jobs: PropTypes.array,
    onRowTouchTap: PropTypes.func.isRequired
  }

  renderRows() {
    const views = []

    let grayBackground = false
    for (const key in this.props.jobs) {
      if (!this.props.jobs.hasOwnProperty(key)) {
        continue
      }

      const job = this.props.jobs[key]

      const backgroundColor = grayBackground ? 'rgba(251, 235, 201, 0.20)' : 'white'

      views.push(
        <ServiceRow
          key={key}
          index={views.length + 1}
          dateStr={this.props.dateStr}
          backgroundColor={backgroundColor}
          eventId={job.eventId}
          onTouchTap={this.props.onRowTouchTap}/>
      )

      grayBackground = !grayBackground
    }
    return views
  }

  render() {
    return (
      <div
        style={{ flex: 1, flexDirection: 'column', display: 'flex', flexGrow:1, textAlign: 'left' }}>
        <ServiceTableHeader />
        <div style={{ display: 'flex', overflow: 'auto', flexDirection: 'column', justifyContent: 'flex-start'}}>
          {this.renderRows()}
        </div>
        {
          //One Photoscreen for the whole table
          <PhotoScreen/>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/reports/service/ServiceTable.js